import { Card, Space, Table } from 'antd';
import React from 'react';

import sharedStyles from '../../sharedStyles.module.scss';
import type {
  CleanKindResult,
  MonthReservationLimit,
  ReservationRuleFormValues,
} from '../../sharedTypes';
import { getCleanKindColumns } from './helper';
import styles from './index.module.scss';

type CleanKindListProps = {
  cleanKindRules: ReservationRuleFormValues | undefined;
  cleanKindAndReservationLimitList:
    | {
        kinds: CleanKindResult[];
        dailyReservationLimits: MonthReservationLimit[][];
      }
    | undefined;
  getLatestData: () => void;
};

const CleanKindList = ({
  cleanKindRules,
  getLatestData,
  cleanKindAndReservationLimitList,
}: CleanKindListProps) => {
  const cleanKindColumns = getCleanKindColumns(cleanKindRules, getLatestData);

  return (
    <Space direction="vertical" className={sharedStyles.widthFull}>
      <Card>
        <Space direction="vertical" className={sharedStyles.widthFull}>
          <span className={styles.tableTitle}>清潔類別</span>
          <Table
            bordered
            rowKey="cleanKindId"
            scroll={{ x: 'max-content' }}
            columns={cleanKindColumns}
            dataSource={cleanKindAndReservationLimitList?.kinds}
          />
        </Space>
      </Card>
    </Space>
  );
};

export default CleanKindList;
